import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './user-tenants.types';
import * as constants from './user-tenants.constants';

export const userTenantsReducer = generateResourceReducer<types.ITenant>({
  STORE: constants.STORE_TENANTS,
  CLEAR: constants.CLEAR_TENANTS,
});
